import React, { useEffect, useState } from "react";
import TableDomesticViolence from "../Tables/TableDomesticViolence";
import InputBasic from "../ProfilesComp/InputsBasic";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateSection } from "../../../store/Profiles/profilesSlice";
import InputsYorN from "../ProfilesComp/InputsYorN";

const StepDomesticViolence = ({ onBack, onNext }) => {
  const dispatch = useDispatch();
  const storedData = useSelector(state => state.profiles.DomesticViolence);
  const storedDataServ = useSelector(state => state.profiles.Service);
  const { t } = useTranslation();
  const [domesticViolenceData, setDomesticViolenceData] = useState({
    haveYouEverBeen: "", // Pregunta de Sí/No
    Areyoucurrently: "", // Pregunta de Sí/No
    Referralstobemade: ""
  });
  const [serviceDate, setServiceDate] = useState({
  });


  useEffect(() => {
    setDomesticViolenceData((prevData) => ({
          ...prevData,
          ...storedData
      }));
      setServiceDate((prevDataSer) => ({
        ...prevDataSer,
        ...storedDataServ
    }));
  }, [storedData,storedDataServ]);

  const handleChange = (field, value) => {
    setDomesticViolenceData((prevData) => ({
        ...prevData,
        [field]: value
    }));
};
  const updateServiceDate = ({selectedServices}) => {
    setServiceDate((prev) => ({ ...prev, ...selectedServices }));
    
  };

  const updateMentalHealthData = (field, value) => {
    setServiceDate((prevData) => ({
      ...prevData,
      [field]: value
  }));
  };

  const handleNextStep = async () => {
    await handleSaveData(); // 🔹 Espera que termine antes de seguir
    onNext();
};

const handleSaveData = async () => {
  dispatch(updateSection({ section: "Service", data: { Service:serviceDate } }));
  dispatch(updateSection({ section: "DomesticViolence", data: { DomesticViolence:domesticViolenceData } }));
}

  return (
    <div>

      <Typography variant="h5" gutterBottom>
          {t("Profiles.DomesticViolence.DomesticViolence")}
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
          <InputsYorN translationKey={t("Profiles.DomesticViolence.Haveyoueverbeen")}
              value={domesticViolenceData.haveYouEverBeen} onChange={(value) => handleChange("haveYouEverBeen", value)} />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
          <InputsYorN translationKey={t("Profiles.DomesticViolence.Areyoucurrently")}
              value={domesticViolenceData.Areyoucurrently} onChange={(value) => handleChange("Areyoucurrently", value)} />
      </Box>

      <Typography variant="h5" gutterBottom>
          {t("Profiles.DomesticViolence.Service")}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt:3}}>
        <TableDomesticViolence updateServiceDate={updateServiceDate} />
      </Box>
      
      <InputBasic
        Translation="Profiles.DomesticViolence.Referralstobemade"
        multiline
        rows={6}
        value={serviceDate.Referralstobemade ?? ""}
        onChange={(e) => updateMentalHealthData("Referralstobemade", e.target.value)}
      />
      
      {/* Botones */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
              {t("common.back")}
          </Button>
          <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
              {t("common.next")}
          </Button>
      </Box>
    </div>
  );
};

export default StepDomesticViolence;
